import Vue from 'vue';
import materialTransformer from './../../transformers/material';
import store from './../../store';

const success = ({ data }) => materialTransformer.fetch(data);

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    const materials = store.state.material.items.filter(p => (
      id.toString() === p.id.toString()
    ));

    if (materials.length > 0) {
      return resolve(materials[0]);
    }

    return Vue.$http.get(`/production/materials/${id}`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/material/show.js